package app.nestbridge.app.monitoring

import app.nestbridge.config.BuildKonfig

val sentryDsn: String get() = BuildKonfig.sentryDsn
val sentryDebug: Boolean get() = BuildKonfig.sentryDebug
val sentryTracesSampleRate: Double get() = BuildKonfig.sentryTracesSampleRate.toDouble()

expect fun initializeSentry(environment: String)
